import axios from 'axios';
import { ErrorMessageResponse } from '../../../common/interfaces/status-message-response';

/**
 * Wrapper para criar um rascunho de solicitação de compra.
 * Internamente usa o mesmo endpoint de solicitação de compra rascunho.
 */
export async function createPurchaseRequestEmit(data: any, token: string): Promise<ErrorMessageResponse> {
  try {
    const response = await axios.post(
      process.env.REACT_APP_BASE_URL + '/solicitacao-compra/emit',
      data,
      {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data) {
      return error.response.data as ErrorMessageResponse;
    }

    return {
      statusCode: 500,
      message: 'Falha ao criar rascunho da solicitação de compra',
    } as any;
  }
}
